import { getMode } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app';
import {
	getRolledUpIssuesLinks,
	getIssueInFocus,
	getGroupBy,
	getDerivedRollupBy,
	getStagePosAndScale,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/dependencies';
import { getDependencyIssueLinkTypesById } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issue-links';
import { getIssueStatusById } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issue-statuses';
import {
	getIsIssuesLoading,
	getIssueMapById,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issues';
import { getSyncStartEnabled } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/plan';
import { getProjectsById } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/projects';
import { getAllSprintsById } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/sprints';
import { getAllTeamsById } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/teams';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createStructuredSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import type { InjectedProps } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/experience-tracking';
import type { OwnProps, StateProps } from './types';

export default createStructuredSelector<State, OwnProps & InjectedProps, StateProps>({
	isLoading: getIsIssuesLoading,
	issueLinkTypesById: getDependencyIssueLinkTypesById,
	projectsById: getProjectsById,
	issuesById: getIssueMapById,
	issueStatusesById: getIssueStatusById,
	dependencyLinks: getRolledUpIssuesLinks,
	issueInFocus: getIssueInFocus,
	teamsById: getAllTeamsById,
	groupBy: getGroupBy,
	rollupBy: getDerivedRollupBy,
	mode: getMode,
	syncStartEnabled: getSyncStartEnabled,
	initialStagePosAndScale: getStagePosAndScale,
	sprintsById: getAllSprintsById,
});
